<template>
  <div class="video-comment-card">
    <!-- AVATAR -->
    <div class="avatar avatar-square avatar_md border-0">
      <img v-lazy="card_img" :alt="card_name" class="avatar-img transparent_bg" v-if="card_img">
      <div
        class="avatar-text white-text font-weight-500 font-14"
        :class="setAvatarBg"
        v-else
      >{{ getInitial }}</div>
    </div>

    <!-- CARD-INFO -->
    <div class="card-info">
      <div class="top">
        <span class="name font-weight-bold brand">{{ card_name }}</span> -
        <span class="date color_grey_dark">{{ timeAgo }}</span>
      </div>
      <div class="mid color_ash">{{ card_comment }}</div>
      <div v-if="false" class="bottom font-weight-bold border_grey_dark pointer">Reply</div>
    </div>
  </div>
</template>

<script>
import { setInitial, getRelativeTime } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "VideoCommentCard",

  props: {
    card_img: String,
    card_name: String,
    card_date: String,
    card_comment: String
  },

  computed: {
    getInitial() {
      return setInitial(this.card_name);
    },

    setAvatarBg() {
      return setProfileBg(this.card_name);
    },

    timeAgo() {
      return getRelativeTime(this.card_date);
    }
  }
};
</script>

<style lang="scss">
.video-comment-card {
  padding: 15px 0px;
  border-bottom: 1px solid #dbdada;
  @include flex_row_start_nowrap;
  align-items: flex-start;

  .avatar {
    margin-right: 20px;

    @include breakpoint_max(xs) {
      margin-right: 10px;
    }
  }

  .card-info {
    .top {
      margin-bottom: 5px;

      .name {
        font-size: 14px;
        line-height: 19px;

        @include breakpoint_max(xs) {
          font-size: 13.5px;
        }
      }

      .date {
        font-size: 12px;
        line-height: 16px;

        @include breakpoint_max(xs) {
          font-size: 11.5px;
        }
      }
    }

    .mid {
      font-size: 14px;
      line-height: 165%;
      margin-bottom: 10px;

      @include breakpoint_max(xs) {
        font-size: 13.5px;
      }
    }

    .bottom {
      font-size: 12px;
      line-height: 165%;
    }
  }
}
</style>
